import { client } from '@/api/common';
import {
  API,
  BASE,
  ME,
  URL_USERS,
  URL_TENANTS,
  V1,
} from '@/lib/constants/urls.ts';
import type { User } from '@repo/database/browser';
import type {
  ListResponse,
  BaseFilterDto,
  TechnicianSeatRowDto,
  TenantSeatSummaryDto,
} from '@repo/api';
import type { UserWithTenantRole } from './models';

export const fetchUserMe = async (
  tenantId: string
): Promise<UserWithTenantRole | undefined> => {
  const response = await client<UserWithTenantRole>({
    url: `${BASE}${API}${V1}${URL_TENANTS}/${tenantId}${URL_USERS}${ME}`,
    method: 'GET',
  });

  return response.data;
};

export const fetchUser = async (
  tenantId: string,
  id?: string
): Promise<UserWithTenantRole | undefined> => {
  const response = await client<UserWithTenantRole>({
    url: `${BASE}${API}${V1}${URL_TENANTS}/${tenantId}${URL_USERS}/${id}`,
    method: 'GET',
  });

  return response.data;
};

export const fetchUsers = async (
  tenantId: string,
  params?: BaseFilterDto
): Promise<ListResponse<User>> => {
  const response = await client<ListResponse<User>>({
    url: `${BASE}${API}${V1}${URL_TENANTS}/${tenantId}${URL_USERS}`,
    method: 'GET',
    params,
  });
  return response.data;
};

export const updateUser = async (
  tenantId: string,
  params: Partial<User>
): Promise<UserWithTenantRole> => {
  const { id, ...data } = params;
  const response = await client<UserWithTenantRole>({
    url: `${BASE}${API}${V1}${URL_TENANTS}/${tenantId}${URL_USERS}/${id}`,
    method: 'PATCH',
    data,
  });
  return response.data;
};

export const deleteUser = async (tenantId: string, id: string) => {
  const response = await client<User>({
    url: `${BASE}${API}${V1}${URL_TENANTS}/${tenantId}${URL_USERS}/${id}`,
    method: 'DELETE',
  });
  return response.data;
};

export const deleteUsers = async (tenantId: string, ids: string[]) => {
  const response = await client<User>({
    url: `${BASE}${API}${V1}${URL_TENANTS}/${tenantId}${URL_USERS}`,
    method: 'DELETE',
    data: { ids },
  });
  return response.data;
};

/** Posti utente e tecnico occupati e inclusi; `null` senza dati commerciali. */
export const fetchUserSeats = async (
  tenantId: string
): Promise<TenantSeatSummaryDto | null> => {
  const response = await client<TenantSeatSummaryDto | null>({
    url: `${BASE}${API}${V1}${URL_TENANTS}/${tenantId}${URL_USERS}/seats`,
    method: 'GET',
  });
  return response.data;
};

/** Membri e inviti che occupano un posto tecnico. */
export const fetchTechnicianSeats = async (
  tenantId: string
): Promise<ListResponse<TechnicianSeatRowDto>> => {
  const response = await client<ListResponse<TechnicianSeatRowDto>>({
    url: `${BASE}${API}${V1}${URL_TENANTS}/${tenantId}${URL_USERS}/technicians`,
    method: 'GET',
  });
  return response.data;
};
